import React from 'react';
import { useNavigate } from 'react-router-dom';
import MovdButton from '../design-system/MovdButton.jsx';
import { movdTokens } from '../design-system/movdTokens.js';

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <main id="main-content" role="main" style={{ padding: 48, textAlign: 'center' }}>
      <p style={{ margin: 0, fontSize: 72, fontWeight: 900, color: movdTokens.color.action.primary }}>404</p>
      <h1 style={{ margin: '8px 0 24px', fontSize: 24, fontWeight: 800 }}>Page not found</h1>
      <MovdButton onClick={() => navigate('/')}>Go home</MovdButton>
    </main>
  );
}
